import styled from '@emotion/styled'

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
`
